/** Defaults when query params are absent (clean URLs). */
export const DEFAULT_TODO_FILTER = "active";
export const DEFAULT_SHOW_MINE = true;
export const DEFAULT_SHOW_TODAY_PLAN = false;

/**
 * @param {URLSearchParams} sp
 * @returns {"all"|"active"|"finished"}
 */
export function parseTodoFilter(sp) {
  const raw = (sp.get("status") || "").toLowerCase();
  if (raw === "done") return "finished";
  if (raw === "all" || raw === "active" || raw === "finished") return raw;
  return DEFAULT_TODO_FILTER;
}

/**
 * @param {URLSearchParams} sp
 */
export function parseTodoMine(sp) {
  const raw = sp.get("mine");
  if (raw === null || raw === "") return DEFAULT_SHOW_MINE;
  return raw === "1" || raw === "true" || raw === "yes";
}

/** Star filter — tasks flagged for today's plan */
export function parseTodoTodayPlan(sp) {
  const raw = sp.get("today_plan");
  if (raw === null || raw === "") return DEFAULT_SHOW_TODAY_PLAN;
  return raw === "1" || raw === "true" || raw === "yes";
}

/** Mobile workspace tab index: 0 = tasks, 1 = journal */
export function parseWorkspaceViewTab(sp) {
  const raw = (sp.get("view") || "").toLowerCase();
  if (raw === "journal") return 1;
  return 0;
}

/** Task list grouping — status (default) or priority */
export function parseTodoGroupBy(sp) {
  const raw = (sp.get("group") || sp.get("groupBy") || "").toLowerCase();
  if (raw === "priority") return "priority";
  return "status";
}

export function parseTodoCreate(sp) {
  return sp.get("create") === "1";
}

/**
 * Merge todo/workspace-related query keys without dropping others (e.g. `view`).
 * Pass `undefined` to omit a key from the patch.
 * Use `null` for `view` to remove it.
 *
 * @param {URLSearchParams} prev
 * @param {{ status?: string; mine?: boolean; todayPlan?: boolean; view?: string | null; groupBy?: string | null; create?: boolean | null }} patch
 */
export function mergeTodoWorkspaceParams(prev, patch) {
  const next = new URLSearchParams(prev);

  if (patch.status !== undefined) {
    const v = patch.status;
    if (v === DEFAULT_TODO_FILTER) next.delete("status");
    else next.set("status", v);
  }

  if (patch.mine !== undefined) {
    const v = patch.mine;
    if (v === DEFAULT_SHOW_MINE) next.delete("mine");
    else next.set("mine", v ? "1" : "0");
  }

  if (patch.todayPlan !== undefined) {
    const v = patch.todayPlan;
    if (v === DEFAULT_SHOW_TODAY_PLAN) next.delete("today_plan");
    else next.set("today_plan", v ? "1" : "0");
  }

  if (patch.view !== undefined) {
    if (patch.view === null || patch.view === "") next.delete("view");
    else next.set("view", patch.view);
  }

  if (patch.groupBy !== undefined) {
    if (!patch.groupBy || patch.groupBy === "status") next.delete("group");
    else next.set("group", patch.groupBy);
  }

  if (patch.create !== undefined) {
    if (!patch.create) next.delete("create");
    else next.set("create", "1");
  }

  return next;
}
